var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"icon-button",attrs:{"disabled":_vm.isDisabled},on:{"click":_vm.onClick}},[_c('icon',{attrs:{"icon":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }